import API from '../../../manager/API';
import { dispatch } from '../../hooks';
import slice from './slice';

const { setDataProcessingGroupByStatusData } = slice.actions;

const dataProcessingGroupByStatus = (url: any) => async () => {
  try {
    const response = await API.dataProcessingGroupByStatus.dataProcessingGroupByStatus(url);
    dispatch(setDataProcessingGroupByStatusData(response.data));
    return { response, status: response.status, data: response.data };
  } catch (error: any) {
    return { status: error.response.status, data: error.response.data };
  }
};

export default {
  dataProcessingGroupByStatus
};
